module.exports = __webpack_public_path__ + "static/navycablestripe-dbce035b55ededb1c2e3b3ad20750281.jpeg";